/**
 * FlexibilityCard — v1.1 refactor.
 * Bilateral flexibility tests (Thomas, Ober, SLR, etc.) with Left/Right
 * result and interpretation. Lifted out of ObjectiveAssessment.jsx.
 */
import React from 'react';
import { Move, Trash2 } from 'lucide-react';

export default function FlexibilityCard({
  rows = [], flexibilityTests = [],
  updRow, addRow, delRow,
  Section, GridTable, AddBtn,
}) {
  return (
    <Section title="Flexibility testing — Left / Right" icon={Move} testid="sec-flex">
      <GridTable cols={['Test','Left result','Right result','Interpretation']}>
        {(rows || []).map((r, i) => (
          <tr key={i} data-testid={`flex-${i}`}>
            <td>
              <select className="input" value={r.test || ''}
                      onChange={(e) => updRow('flexibility', i, { test: e.target.value })}>
                <option value="">—</option>
                {flexibilityTests.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </td>
            <td>
              <input className="input" value={r.left || ''}
                     onChange={(e) => updRow('flexibility', i, { left: e.target.value })}/>
            </td>
            <td>
              <input className="input" value={r.right || ''}
                     onChange={(e) => updRow('flexibility', i, { right: e.target.value })}/>
            </td>
            <td>
              <input className="input" value={r.interpretation || ''}
                     onChange={(e) => updRow('flexibility', i, { interpretation: e.target.value })}
                     placeholder="WNL / restricted"/>
            </td>
            <td className="print:hidden">
              <button onClick={() => delRow('flexibility', i)} className="text-[#B83A3A] p-1">
                <Trash2 className="w-4 h-4"/>
              </button>
            </td>
          </tr>
        ))}
      </GridTable>
      <AddBtn onClick={() => addRow('flexibility', {
        test: '', left: '', right: '', interpretation: '',
      })} testid="add-flex"/>
    </Section>
  );
}
